// extracted by mini-css-extract-plugin
module.exports = {"compareModal":"styles_compareModal__1168P","loadingContainer":"styles_loadingContainer__nMyVK"};